module.exports = __webpack_public_path__ + "static/resume-18ab877e3609ac1054fcea0acee0d175.pdf";